<div class="statistics statistics-offer" *ngIf="offer">
  <div class="row section-filter">
    <div class="col-md-12">
      <!-- Date Filter -->
      <mat-form-field>
        <mat-label>{{'SUPPORT.FILTER.DATE.TITLE' | translate}}</mat-label>
        <input matInput [(ngModel)]="dateFilter" [matDatepickerFilter]="activeDates.bind(this)" [matDatepicker]="startDateFilterPicker" [max]="maxDate" (dateChange)="applyFilterDate($event)">
        <mat-datepicker-toggle matSuffix [for]="startDateFilterPicker"></mat-datepicker-toggle>
        <mat-datepicker #startDateFilterPicker></mat-datepicker>
      </mat-form-field>
      <button *ngIf="dateFilter" class="clear-button" (click)="clearFilterDate()">
        {{'STATISTICS.CLEAR_FILTER' | translate}}
      </button>
    </div>
  </div>
  <div *ngIf="statistics">
    <h3 class="stat-heading">
      {{'STATISTICS.OFFER_REDEEM' | translate}}
      <span class="date-filter" *ngIf="dateFilter">
        [{{dateFilter | date: 'dd/MM/yyyy'}}]
      </span>
      <span class="date-filter" *ngIf="!dateFilter">
        [{{'STATISTICS.TOTAL' | translate}}]
      </span>
    </h3>
    <div class="row">
      <div class="col-md-4">
        <mat-card>
          <mat-card-title>
            {{'STATISTICS.QUANTITY' | translate}}
          </mat-card-title>
          <mat-card-content>
            {{statistics['redeem'].quantity}}
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-4">
        <mat-card>
          <mat-card-title>
            {{'STATISTICS.USERS' | translate}}
          </mat-card-title>
          <mat-card-content>
            {{statistics['redeem'].uniqueUsers.length}}
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-4">
        <mat-card>
          <mat-card-title>
            {{'STATISTICS.TRANSACTIONS' | translate}}
          </mat-card-title>
          <mat-card-content>
            {{statistics['redeem'].uniqueTransactions.length}}
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div>
      <button mat-raised-button class="export-button" (click)="exportToCsv()">
        <span class="mdi mdi-export-variant"></span>
      </button>
      <!-- <button mat-raised-button class="export-button" (click)="exportToCSV(statistics)">
        <span class="mdi mdi-export-variant"></span>
      </button> -->
    </div>
  </div>
</div>
